import { makeStyles } from '@material-ui/styles';
import { DefaultTheme } from '@material-ui/styles';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

const useStyles = makeStyles<DefaultTheme>({
    grid_root: {
        backgroundColor: 'transparent',
    },
    grid_title_buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        alignContent: 'center',
        alignItems: 'center',
        margin: '10px 0px 15px 0px !important'
    },
    paper: {
        width: '100%',
    },
    grid_root_exam_item: {
        padding: '5px !important',
        backgroundColor: '#EEEEEE',
        '&:hover': {
            backgroundColor: '#CCCCCC',
        }
    },
    data_is_empty: {
        width: '100%',
        display: 'flex',
        backgroundColor: 'transparent',
        color: '#06617c !important',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        marginTop: '50px !important',
    },
    grid_exam_title_item: {
        display: 'flex',
        flexDirection: 'row'
    },
    grid_exam_item: {
        marginRight: '3px !important',
        flexDirection: 'column',
        color: '#000000 !important',
        cursor: 'pointer !important',
        '&:hover': {
            color: '#06617c !important',
        }
    },
    button_create: {
        display: 'flex',
        borderRadius: '10px !important',
        backgroundColor: 'transparent',
        color: '#06617c !important',
        border: '1px solid #06617c !important',
        alignItems: 'center',
        marginBottom: '10px !important',
    },
    grid_datagrid: {
        height: 'auto',
        marginTop: '15px !important',
    },
    datagrid: {
        minHeight: '634px',
        '& .MuiDataGrid-main .MuiDataGrid-virtualScroller .MuiDataGrid-virtualScrollerContent .MuiDataGrid-virtualScrollerRenderZone .MuiDataGrid-row': {
            maxHeight: 'max-content !important',
        },
        '& .MuiDataGrid-main .MuiDataGrid-virtualScroller .MuiDataGrid-virtualScrollerContent .MuiDataGrid-virtualScrollerRenderZone .MuiDataGrid-row .MuiDataGrid-cell': {
            maxHeight: 'max-content !important',
        }
    },
    title: {
        margin: '10px 0px 20px 0px'
    },
});

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default useStyles;